import { render } from "./WorkPlaceDetailModal.vue?vue&type=template&id=5b905811"
import script from "./WorkPlaceDetailModal.vue?vue&type=script&lang=ts"
export * from "./WorkPlaceDetailModal.vue?vue&type=script&lang=ts"
script.render = render

export default script